import { render, staticRenderFns } from "./attendee-field-form.vue?vue&type=template&id=32e68760&scoped=true"
import script from "./attendee-field-form.vue?vue&type=script&lang=js"
export * from "./attendee-field-form.vue?vue&type=script&lang=js"
import style0 from "./attendee-field-form.vue?vue&type=style&index=0&id=32e68760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e68760",
  null
  
)

export default component.exports